// @flow
import React, { useEffect, useState } from "react";
import { reduxForm } from "redux-form";
import type { FormProps } from "redux-form";
import { useSelector } from "react-redux";

import { fromSlug, getSlug } from "Commons/Modules/category";
import { getProviders } from "redux/sagas/selectors";
import type { State as ProvidersState } from "redux/reducers/providers";
import { VARIATIONS } from "../misc/Types";
import type { ShortOfferFormPropsT } from "../misc/Types";
import { PROPERTY_STEPS } from "../misc/Steps";
import { TransitionForm } from "./TransitionForm";
import { IframeTransitionForm } from "./IframeTransitionForm";
import { ME } from "modules/ChangeService/misc/Constants";

import "./ShortOfferThemed.scss";
import { TemporaryStorage } from "../../../Commons/Utilities/storage";

let ShortOfferForm = function ShortOfferForm(props: ShortOfferFormPropsT & FormProps) {
  const { id, variation, categorySlug, valid, invalid, pristine, reset, change, resetSection, isAnon } = props;
  const providers: ProvidersState = useSelector(getProviders);
  const categoryType = fromSlug(categorySlug);
  const [currentTab, setCurrentTab] = useState(categoryType);

  //onMount clear away any LoginRedirect
  useEffect(() => {
    TemporaryStorage.delAfterLoginRedirectURL();
  }, []);

  switch (variation) {
    case VARIATIONS.NATIVE_LIGHT_FORM_FOLDED_CARDS:
    case VARIATIONS.LANDING_DEFAULT:
    case VARIATIONS.LANDING_ARTICLE: {
      return (
        <TransitionForm
          id={id}
          key={variation}
          STEPS={PROPERTY_STEPS}
          variation={variation}
          categorySlug={getSlug(currentTab)}
          onCategoryChange={setCurrentTab}
          change={change}
          providers={providers}
          valid={valid}
          invalid={invalid}
          pristine={pristine}
          reset={reset}
          resetSection={resetSection}
        />
      );
    }
    case VARIATIONS.IFRAME: {
      return (
        <IframeTransitionForm
          id={id}
          key={variation}
          STEPS={PROPERTY_STEPS}
          categorySlug={getSlug(currentTab)}
          onCategoryChange={setCurrentTab}
          change={change}
          providers={providers}
          valid={valid}
          invalid={invalid}
          pristine={pristine}
          reset={reset}
          resetSection={resetSection}
          isAnon={isAnon}
        />
      );
    }

    default:
      break;
  }
};

ShortOfferForm = reduxForm({
  form: "shortOffer",
  initialValues: {
    onBehalfOf: ME,
  },
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(ShortOfferForm);

export default ShortOfferForm;
